import getUserConfiguration from "../actions/getUserConfiguration";
import { getApplicationSettings } from "owa-application-settings";
import type OutlookNewslettersAccessLevels from "owa-service/lib/contract/OutlookNewslettersAccessLevels";

export default function getOutlookNewslettersAccessLevel(): OutlookNewslettersAccessLevels {
    const accessLevel = getUserConfiguration().PolicySettings?.OutlookNewslettersAccessLevel;
    
    if (accessLevel == undefined || accessLevel === 0) {
        const { newslettersAccessLevel } = getApplicationSettings("NewslettersPolicyFallback");
        return newslettersAccessLevel as OutlookNewslettersAccessLevels;
    }
    else {
        return accessLevel;
    }
}
